import { contrastRatio, GREY_LIGHT_HEX } from './colorContrast';
import { parseHexColor, type Rgb } from './parseHexColor';

/** Die beiden Text-Token aus `core/styles/styles.scss` (`--grid-card-text` / `--grid-card-text-light`). */
const TEXT_DARK = 'var(--grid-card-text)';
const TEXT_LIGHT = 'var(--grid-card-text-light)';

/**
 * RGB-Werte der beiden Token, gespiegelt aus `core/styles/global.scss`
 * (`--color-grey-darkest` / `--color-grey-lightest`). Nötig, weil der Kontrast
 * gerechnet werden muss – CSS-Variablen sind hier nicht auflösbar.
 */
const TEXT_DARK_RGB: Rgb = [0x0e, 0x0e, 0x2c];
const TEXT_LIGHT_RGB: Rgb = [0xf2, 0xf2, 0xf8];

/**
 * Textfarbe passend zum Kartenhintergrund: es gewinnt die der beiden Token-Farben, die auf dem
 * Hintergrund stärker kontrastiert. Gedacht für Einzelfarben (z.B. die Fachfarbe).
 *
 * Bewusst kontrastbasiert statt über eine Helligkeitsschwelle: eine Schwelle kippt bei mittleren
 * Farben (z.B. `#CD5C5C`, `#4682B4`) auf hellgrauen Text, der dort schlechter lesbar ist als
 * dunkler. Ist der Farbwert nicht als Hex lesbar, ist dunkler Text die sichere Wahl – hellgrauer
 * Text auf einer womöglich hellen Fläche wäre der schlechtere Fehlerfall.
 */
export const getCardTextColor = (color: string): string => {
  const rgb = parseHexColor(color);
  if (!rgb) return TEXT_DARK;
  return contrastRatio(rgb, TEXT_LIGHT_RGB) > contrastRatio(rgb, TEXT_DARK_RGB) ? TEXT_LIGHT : TEXT_DARK;
};

/**
 * Textfarbe einer Karte, die ihre Fachfarbe zeigt. Ohne gepflegte Fachfarbe fällt die Karte auf
 * ihren grauen Hintergrund (`--color-grey-light`) zurück – dagegen wird dann gerechnet.
 *
 * Bewusst ohne den Schalter als Parameter: So bleibt die Funktion eine reine Ableitung aus der
 * Fachfarbe und die Aufrufer brauchen keinen Store-Zugriff. Im Stundenplan-Board hängt die
 * Umschaltung an `data-color-by-subject` am Board-Container und wird in CSS entschieden; ein
 * Store-Abo je Kärtchen würde diese Optimierung aushebeln.
 */
export const getSubjectCardTextColor = (subjectColor: string | null | undefined): string =>
  getCardTextColor(subjectColor || GREY_LIGHT_HEX);
